// src/common/hooks/useEventIndexesAndRankPoints.js
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { calculateIndividualRankPoints } from "../../utils/utilityFunctions";

function useEventIndexesAndRankPoints(firstRankPoints, lastRankPoints) {
  const eventData = useSelector((state) => state.matches);
  const [individualRankPoints, setIndividualRankPoints] = useState([]);

  const currentRoundIndex = eventData?.currntgroupindex?.currentourndindex;
  const currentGroupIndex = eventData?.currntgroupindex?.gindex;
  const currentMatchIndex = eventData?.currntgroupindex?.submatchindex;

  const currentGroupData = eventData?.matches?.rounds?.[currentRoundIndex]?.[currentGroupIndex];
  const teamsInGroup = currentGroupData?.matches?.[currentMatchIndex]?.table?.length;

  useEffect(() => {
    const rankPoints = calculateIndividualRankPoints({
      firstRankPoints,
      lastRankPoints,
      teamsInGroup
    });
    setIndividualRankPoints(rankPoints);
  }, [firstRankPoints, lastRankPoints, teamsInGroup]);

  return {
    teamsInGroup,
    currentRoundIndex,
    currentGroupIndex,
    currentMatchIndex,
    individualRankPoints
  };
}

export default useEventIndexesAndRankPoints;
